import { CreateNewInvoiceParams, ResolveDisputeParams } from 'src/components/pages/invoicing/types';
import { OrgTypes } from 'src/Library/Constants';
import { PLATFORM_BASENAME } from './../globals';

export const getDashboardRoute = (dashboardId) => {
  return `/dashboard/${dashboardId}`;
};

export const getPlayRoute = () => {
  return '/play';
};

export const getAllDashboardsRoute = () => {
  return '/allDashboards';
};

export const getExceptionRulesRoute = () => {
  return '/exceptionrules';
};

export const getSliceRoute = (sliceId) => {
  return `/slice/${sliceId}/edit`;
};

export const getAlertDefinitionsRoute = () => {
  return '/alerts/definitions';
};
export const getNotificationsRoute = (orgType) => {
  return `/${orgType}/notifications`;
}
export const getAlertInstancesRoute = () => {
  return '/alerts/instances';
};

export const getExceptionAlertInstanceDetailsRoute = (exceptionAlertInstanceId) => {
  return `/alerts/instance/${exceptionAlertInstanceId}`;
};

export const getTeamManagementRoute = () => {
  return '/teams';
};

export const getUserManagementRoute = () => {
  return '/users';
};

export const getTnCRoute = () => {
  return '/tnc';
};

export const getChargeMasterRoute = () => {
  return '/chargeMaster';
};

export const getLogoutRoute = () => {
  return '/logout';
};

export const getAccountRoute = () => {
  return '/account';
};

export const getCustomConfigRoute = () => {
  return '/customConfig';
}

export const getBusinessUnitRoute = () => {
  return '/customConfig/businessUnit';
}

export const getCreateExceptionRuleRoute = () => {
  return '/exceptionrule/create';
};

export const getEditExceptionRuleRoute = (id) => {
  return `/exceptionrule/edit/${id}`;
};

export const getCreateUserRoute = () => {
  return '/users/create';
};

export const getLoginRoute = () => {
  return `${PLATFORM_BASENAME}/login`;
};

export const getForgotPasswordRoute = () => {
  return `${PLATFORM_BASENAME}/forgot-password`;
};

export const getContainerTrackingRoute = (eximType, tabId = 'insights') => {
  if (eximType) {
    return `/${eximType}/container/tab/${tabId}`;
  }
  return `/track/${tabId}`;
};

export const getCreateBulkShipmentRoute = () => {
  return '/track/createBulkShipment';
}

export const getContainerDetailsRoute = (id, shipmentType, containerId ?: string) => {
  return containerId ? `/container/detail/${shipmentType}/${id}/containers/${containerId}` :
    `/container/detail/${shipmentType.toLowerCase()}/${id}/containers/`;
};

export const getImportDetailRoute = (id) => {
  return `/imports/detail/${id}`;
};

export const getExportsRoute = () => {
  return '/exports';
};

export const getAirCargoRoute = () => {
  return '/airCargo/airCargo';
};

export const getFreightForwardedRoute = () => {
  return '/airCargo/freightForwarder';
};

export const getImportRoute = () => {
  return '/imports';
};

export const getExportDetailRoute = (id) => {
  return `/exports/detail/${id}`;
};

export const getPermissionsRoute = () => {
  return '/permissions';
};

export const getDomesticTrackRoute = () => {
  return '/domestic/track';
};

export const getBiddingAllPlansRoute = () => {
  return '/rfq/bidding';
};

export const getBiddingDetailsRoute = (rfqPlanId) => {
  return `/biddingDetails/${rfqPlanId}`;
};

export const getRFQAllPlansRoute = () => {
  return '/rfq/shipper';
};

export const getRFQAllLineItemsRoute = ({ tab }) => {
  return `/rfq/shipper/lineItems/${tab}`;
};

export const getRfqLocalRateMasterRoute = () => {
  return '/rfq/locals/ratemaster';
};

export const getRfqBulkRequest = () => {
  return '/bulkRequest/bulkDownload';
};

export const getAddLineItemsRoute = (rfqPlanId) => {
  return `/rfq/shipper/detail/add/${rfqPlanId}`;
};

export const getRFQPlanDetailRoute = (rfqPlanId, tab: 'main' | 'amended' = 'main') => {
  return `/rfq/shipper/detail/${tab}/${rfqPlanId}`;
};

export const getAllBidsForLineItemRoute = (rfqPlanId, lineItemId) => {
  return `/rfq/shipper/detail/bid/${rfqPlanId}/${lineItemId}`;
};

export const getRfqFlexibleReports = () => {
  return `/rfq/flexibleReports`;
};

export const getRakeRoute = () => {
  return '/rake';
};


export const getSalesOrderRoute = (eximType) => {
  return `/${eximType}/salesorder`;
};


export const getRfqAnalyticsRoute = () => '/rfq/analytics';

// RFQ vendor type check — SHIPPING_LINE and FF use old RFQ components
export const isOldRfqVendorType = (vendorType?: string | null): boolean => {
  return vendorType === 'SHIPPING_LINE' || vendorType === 'FF';
};

export const getOldRFQPlanDetailRoute = (rfqPlanId, tab: 'main' | 'amended' = 'main') => {
  return `/rfq/old/shipper/detail/${tab}/${rfqPlanId}`;
};

export const getOldBiddingDetailRoute = (rfqPlanId) => {
  return `/biddingDetails/${rfqPlanId}`;
};

// RFQ Next (revamp) routing utilities
export const getTenderDetailRoute = (tenderId, tab: 'main' | 'amended' = 'main') => {
  return `/rfq/shipper/detail/${tab}/${tenderId}`;
};

export const getAddTenderLineItemsRoute = (tenderId) => {
  return `/rfq/shipper/detail/add/${tenderId}`;
};

export const getTenderAllLineItemsRoute = ({ tab }: { tab: string }) => {
  return `/rfq/shipper/lineItems/${tab}`;
};

export const getRFQVendorRoute = () => '/rfq/vendor';

export const getRFQVendorDetailsRoute = (tenderId) => {
  return `/rfq/vendor/details/${tenderId}`;
};

export const getDomesticCarrierManagementRoute = () => '/domestic/carrierManagement';
export const getCustomerActivityRoute = () => '/customerActivity';
export const getDomesticCarrierManagementDetailsRoute = carrierId =>
  `/domestic/carrierManagement/detail/${carrierId}`;

export const getSetupMastersRoute = (tabId: string) => {
  const id = tabId === 'FF' ? 'VENDOR' : tabId;
  return `/masters/${id?.toLowerCase()}`;
};

export const getInquiryShipperRoute = (modeList = '') => {
  if (modeList) return `/inquiry/shipper?${modeList}`;
  return '/inquiry/shipper'
};

export const getInquiryFFRoute = (modeList = '') => {
  if (modeList) return `/inquiry/ff?${modeList}`;
  return `/inquiry/ff`;
};

export const getInquiryDetailRoute = (type, inquiryId, tabId = 'details') => {
  return `/inquiry/details/${type}/${inquiryId}/tab/${tabId}`;
};
export const getInquiryEditRoute = (inquiryId) => {
  return `/inquiry/shipper/edit/${inquiryId}`;
};

export const getCreateInquiryRoute = () => {
  return '/inquiry/shipper/createInquiry/';
};
export const getDuplicateInquiryRoute = (inquiryId) => {
  return `/inquiry/shipper/createInquiry/${inquiryId}`;
};
export const getInquiryCreateBidRoute = (inquiryId) => {
  return `/inquiry/ff/createbid/${inquiryId}`;
};
export const getAddOfflineBidRoute = (inquiryId) => {
  return `/inquiry/shipper/addOfflineBid/${inquiryId}`;
};

export const editBidForInquiryRoute = (inquiryId, bidId) => {
  return `/inquiry/ff/editbid/${inquiryId}/${bidId}`;
};

export const bookingShipperRoute = (modeList = '') => {
  if (modeList) return `/booking/shipper?${modeList}`;
  return '/booking/shipper';
};

export const bookingFFRoute = (modeList = '') => {
  if (modeList) return `/booking/ff?${modeList}`;
  return '/booking/ff';
};
export const getShipmentsListRoute = (orgType: 'shipper' | 'ff') => {
  return `/execution/${orgType}`;
};
export const getContainerDetailRoute = (shipmentType, shipmentId, tabId, containerId?: string) => {
  const route = `/container/detail/${shipmentType}/${shipmentId}/${tabId}`;
  if (containerId) return `${route}/${containerId}`;
  return route;
};
export const getOrganisationRoute = (orgId = undefined, orgType = undefined) => {
  if (orgId && orgType) {
    return `/organisation/${orgType}/${orgId}`;
  }
  return '/organisation';
};
export const getCreateShipmentRoute = () => {
  return '/execution/shipper';
};

/**
 * Invoicing
 */
export const getCreateInvoiceRoute = ({ sourceType, sourceId }: CreateNewInvoiceParams) => {
  if (sourceType && sourceId) {
    return `/invoice/create/${sourceType}/${sourceId}`;
  }
  return '/invoice/create/';
};

export const getInvoicingRoute = (type = 'payables', invoiceId = undefined) => {
  if (invoiceId) return `/invoice/${type}/${invoiceId}`;
  return `/invoice/${type}`;
};
export const getInvoiceActivityTimeLineRoute = (type) => {
  return `/invoice/activity/${type}`;
};

export const getViewInvoiceRoute = ({ invoiceId } : ResolveDisputeParams) => {
  return `/invoice/view/${invoiceId}`;
};

export const getReviewInvoiceRoute = ({ invoiceId } : ResolveDisputeParams) => {
  return `/invoice/review/${invoiceId}`;
};

export const getInvoiceAgeingViewRoute = (type) => {
  return `/invoice/ageingview/${type}`;
};

export const getInvoiceResolveDisputeRoute = (invoiceId) => {
  return `/invoice/resolve/${invoiceId}`;
};

export const getApiDocsRoute = () => '/api';

export const getTriangulationRoute = () => '/triangulation';

export const getRateMasterRoute = () => {
  return '/rateMaster';
};

export const getBulkRequestRoute = () => {
  return '/bulkRequest';
};

export const getPortGroupsRoute = () => {
  return '/port-groups';
}
export const getEditBidRoute = (inquiryId: string) => {
  return `/inquiry/details/ff/${ inquiryId }/tab/bids`;
};

export const getDiscoverRatesRoute = (viewType: string) => {
  return `/discover-${viewType}-rates`;
};

export const getDiscoverRatesLandingPageRoute = () => {
  return '/discover-rates';
};

export const getDsrTemplateRoute = () => {
  return '/dsr/template';
}
;
export const getCreateDsrTemplateRoute = () => {
  return '/dsr/template/create';
};

export const getDemurrageDetentionRoute = () => {
  return '/demurrage-and-detention';
};

export const getMarkupAutomationToolRoute = () => {
  return '/markup';
};

export const getCreateTrackingRoute = (id?: string) => {
  if (id) return `/track/edit/${id}`;
  return '/track/create';
}

export const getShipmentExecutionShipperRoute = () => {
  return '/execution/shipper';
};

export const getShipmentExecutionFFRoute = () => {
  return '/execution/ff';
};

export const getVesselSchedulesRoute = () => {
  return '/vessel-schedules';
};

export const getAirCargoDetailsRoute = (type: 'freightForwarded' | 'airCargo', id: string) => {
  return type === 'airCargo' ? `/airCargo/details/${id}` : `/freightForwarder/details/${id}`;
}

export const getMyRegionstemplateRoute = () => {
  return '/masters/regions';
};

export const getAnalyticsRoute = () => {
  return '/analytics/dashboard';
}

export const getSubscriptionPlanRoute = () => {
  return '/subscription-plan';
}

export const getTasksWorkflowRoute = () => {
  return '/tasks-workflow'
}
export const getHomeRoute = () => {
  return '/';
}

export const getApprovalPoliciesRoute = () => {
  return '/approval-policies';
};

export const getMyApprovalsRoute = () => {
  return '/my-approvals';
};
